<template>
  <section class="p-2 mt-2 order-attachment-grid attachment-border">
    <thumbnail  :thumbnail-url="contentUrl"   
                thumbnail-type="attachment"
                style="height: 128px; width: 128px;"/>
    <article>
      <h6 style="align-self: center;"
          class="mt-6">
        {{ fileName }}
      </h6>
      <article style="float: right;">
        <slot name="download">
          <a  :href="contentUrl"
              :download="fileName"
              class="button mx-1"
              type="button" >
            <span class="icon fas fa-download is-small"/>
            <span>{{ $t("download") }}</span>
          </a>
        </slot>
        <template v-if="canEdit">
          <button class="button mx-1"
                  data-unit="edit-trigger"
                  @click="handleEdit">
            <span class="icon fas fa-edit" />
            <span>{{ $t('edit') }}</span>
          </button>
          <button class="button is-light is-danger mx-1"
                  data-unit="delete-trigger"
                  @click="$emit('delete')">
            <span class="icon fas fa-trash" />
            <span>{{ $t('delete') }}</span>
          </button>
        </template>
      </article>
      <drop-zone ref="fileUpload" @change="handleFileReplace"/>
    </article>
  </section>
</template>

<script setup lang="ts">
import { ref } from "vue"
import Thumbnail from "@/components/common/Thumbnail.vue"
import DropZone from "@/components/admin/content/editor/DropZone.vue"

const fileUpload = ref<InstanceType<typeof DropZone> | null>(null)

const emit = defineEmits([ "delete","replace" ])

type Props = {
  fileName: string,
  contentUrl: string,
  canEdit: boolean
}
const props = defineProps<Props>()

function handleEdit() {
  fileUpload.value?.browse()
}

function handleFileReplace(file: File) {
  emit("replace", file)
}
</script>

<style scoped lang="scss">
  .actions {
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    flex-wrap: wrap;

    > * {
      margin-left: 0.5rem;
    }
  }

  .order-attachment-grid {
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 1rem;
  }

  .attachment-border {
    border: 1px solid lightgrey;
    border-spacing: 2px;
  }

  .dropzone {
    display: none;
  }
</style>